import React from 'react';
import Box from '../Box/Box';
import Grid from '../Grid/Grid';

export const SECTION_VERTICAL_PADDING = 60;

const SectionWrapper = React.forwardRef(
    // @ts-ignore
    ({ children, backgroundVariant, backgroundGradient, ...props }, ref) => (
        <Box
            py={SECTION_VERTICAL_PADDING}
            background={
                backgroundGradient ? backgroundGradient : backgroundVariant
            }
            backgroundColor={backgroundVariant}
            position="relative"
            // @ts-ignore
            ref={ref}
            {...props}
        >
            <Grid>{children}</Grid>
        </Box>
    )
);

export default SectionWrapper;
